(() => {
  const footerViewport = matchMedia('(max-width: 900px)');
  const footerDisclosures = [...document.querySelectorAll('.footer-responsive')];
  const syncFooter = () => footerDisclosures.forEach((item) => {
    item.open = !footerViewport.matches || Boolean(item.querySelector('.errors, .newsletter-message:not(:empty)'));
    item.querySelector('summary')?.setAttribute('tabindex', footerViewport.matches ? '0' : '-1');
  });
  syncFooter();
  footerViewport.addEventListener('change', syncFooter);
  footerDisclosures.forEach((item) => item.querySelector('summary')?.addEventListener('click', (event) => {
    if (!footerViewport.matches) event.preventDefault();
  }));
  const menuButton = document.querySelector('.mobile-menu');
  const nav = document.querySelector('#primary-navigation');
  const search = document.querySelector('.site-header-search');
  const searchButton = search?.querySelector('.search-tool');
  let menuOverflow = '';
  const menuBackground = new Map();
  const setMenuOpen = (open) => {
    const wasOpen = menuButton?.getAttribute('aria-expanded') === 'true';
    menuButton?.setAttribute('aria-expanded', String(open));
    nav?.classList.toggle('mobile-open', open);
    if (open && !wasOpen) {
      menuOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.querySelectorAll('main, .site-footer').forEach(element => {
        menuBackground.set(element, element.inert);
        element.inert = true;
      });
    } else if (!open && wasOpen) {
      document.body.style.overflow = menuOverflow;
      menuBackground.forEach((inert, element) => { element.inert = inert; });
      menuBackground.clear();
    }
    if (!open) navMenus.forEach(menu => { menu.open = false; });
  };
  const navMenus = [...document.querySelectorAll('#primary-navigation .nav-menu')];
  navMenus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      navMenus.forEach((otherMenu) => {
        if (otherMenu !== menu) otherMenu.open = false;
      });
    });
  });
  document.addEventListener('pointerdown', (event) => {
    navMenus.forEach((menu) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  });
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    closeSearch(false);
    setMenuOpen(!open);
  });
  const closeSearch = (restoreFocus = true) => {
    search?.classList.remove('is-open');
    searchButton?.setAttribute('aria-expanded', 'false');
    const history = search?.querySelector('[data-search-history]');
    if (history) history.hidden = true;
    if (restoreFocus) searchButton?.focus();
  };
  search?.querySelector('.search-close')?.addEventListener('click', () => closeSearch());
  searchButton?.addEventListener('click', () => {
    setMenuOpen(false);
    search?.classList.add('is-open');
    searchButton?.setAttribute('aria-expanded', 'true');
    search?.querySelector('input[type="search"]')?.focus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const restoreSearchFocus = search?.classList.contains('is-open') && search.contains(document.activeElement);
    const restoreMenuFocus = menuButton?.getAttribute('aria-expanded') === 'true';
    closeSearch(restoreSearchFocus);
    setMenuOpen(false);
    if (restoreMenuFocus) menuButton?.focus();
  });
  footerViewport.addEventListener('change', () => {
    setMenuOpen(false);
    closeSearch(false);
  });

  let track123LabelIndex = 0;
  const labelTrack123Inputs = (root = document) => {
    const containers = [];
    if (root instanceof Element && root.matches('.track123-input-content')) containers.push(root);
    root.querySelectorAll?.('.track123-input-content').forEach((container) => containers.push(container));
    containers.forEach((container) => {
      const input = container.querySelector('.track123-input');
      const label = container.querySelector('.track123-input-label');
      if (!input || !label) return;
      if (!label.id) label.id = `humble-track123-label-${++track123LabelIndex}`;
      input.setAttribute('aria-labelledby', label.id);
    });
  };
  labelTrack123Inputs();
  const track123Observer = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node instanceof Element) labelTrack123Inputs(node);
    }));
  });
  track123Observer.observe(document.body, { childList: true, subtree: true });

  if ((document.querySelector('[data-home-images]') || window.Shopify?.designMode) && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.setInterval(() => {
      document.querySelectorAll('[data-home-images]').forEach((group) => {
        if (document.hidden) return;
        const images = [...group.querySelectorAll('img')];
        if (images.length < 2) return;
        const current = images.findIndex((image) => image.classList.contains('is-current'));
        let next = Math.floor(Math.random() * (images.length - 1));
        if (next >= current) next += 1;
        const candidate = images[next];
        const reveal = () => {
          if (!group.isConnected || document.hidden) return;
          images.forEach((image, index) => image.classList.toggle('is-current', index === next));
        };
        if (candidate.dataset.src) {
          const source = candidate.dataset.src;
          const sources = candidate.dataset.srcset;
          candidate.onload = () => { candidate.onload = null; candidate.onerror = null; reveal(); };
          candidate.onerror = () => { candidate.dataset.src = source; if (sources) candidate.dataset.srcset = sources; };
          candidate.loading = 'eager';
          if (candidate.dataset.srcset) candidate.srcset = candidate.dataset.srcset;
          candidate.src = candidate.dataset.src;
          delete candidate.dataset.src;
          delete candidate.dataset.srcset;
        } else if (candidate.complete && candidate.naturalWidth > 0) reveal();
      });
    }, 5000);
  }

  let restoringCollection = true;
  const collectionSections = new Map();
  const collectionPreparation = new WeakMap();
  async function prepareCollectionGrid(grid) {
    if (!grid.hasAttribute('data-custom-newest')) return true;
    const section = grid.closest('.shopify-section');
    const oldButton = section.querySelector('[data-load-more]');
    try {
      // Shop all uses the merchant's launch order for Newest, across every page.
      const url = new URL(location.href);
      url.searchParams.set('sort_by', 'manual');
      url.searchParams.set('section_id', grid.dataset.customNewest);
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Unable to load launch order');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = page.querySelector('[data-product-grid]');
      if (!nextGrid || nextGrid.hasAttribute('data-custom-newest')) throw new Error('Product grid missing');
      if (!grid.isConnected) return false;
      grid.innerHTML = nextGrid.innerHTML;
      const nextButton = page.querySelector('[data-load-more]');
      if (nextButton) {
        const nextUrl = new URL(nextButton.dataset.nextUrl, location.href);
        nextUrl.searchParams.set('sort_by', 'manual');
        nextUrl.searchParams.delete('section_id');
        nextButton.dataset.nextUrl = nextUrl.pathname + nextUrl.search;
        if (nextButton.tagName === 'A') nextButton.href = nextButton.dataset.nextUrl;
        if (oldButton) oldButton.replaceWith(nextButton);
        else grid.after(nextButton);
      } else oldButton?.remove();
      grid.removeAttribute('data-custom-newest');
      return true;
    } catch {
      if (!grid.isConnected) return false;
      grid.replaceChildren();
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'load-more';
      retry.textContent = oldButton?.dataset.error || 'Unable to load products. Try again.';
      retry.addEventListener('click', () => location.reload());
      grid.append(retry);
      return false;
    } finally {
      grid.style.removeProperty('visibility');
      grid.removeAttribute('aria-busy');
    }
  }
  function initializeCollectionSection(productGrid) {
    if (collectionSections.has(productGrid)) return;
    const section = productGrid.closest('.shopify-section') || productGrid.parentElement;
    const controller = new AbortController();
    const { signal } = controller;
    const on = (target, type, handler) => target?.addEventListener(type, handler, { signal });
    const loadMoreButton = section.querySelector('[data-load-more]');
    productGrid.dataset.loadedPages ||= loadMoreButton?.dataset.loadedPages || '1';
    const isActive = () => !signal.aborted && productGrid.isConnected;
    let loading = false;
    let automaticPaused = false;
    let observer;
    let observeFrame;
    const observeMore = () => {
      cancelAnimationFrame(observeFrame);
      observeFrame = requestAnimationFrame(() => {
        if (!isActive() || !loadMoreButton?.isConnected || !loadMoreButton.hasAttribute('data-auto-load') || automaticPaused) return;
        observer?.unobserve(loadMoreButton);
        observer?.observe(loadMoreButton);
        if (restoringCollection || document.hidden || loading) return;
        const bounds = loadMoreButton.getBoundingClientRect();
        const viewportBottom = window.visualViewport ? window.visualViewport.offsetTop + window.visualViewport.height : window.innerHeight;
        if (bounds.height > 0 && bounds.top <= viewportBottom + 200) void loadNextPage();
      });
    };

    section.querySelectorAll('[data-sort-select]').forEach((select) => {
      on(select, 'change', () => {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        location.assign(url.toString());
      });
    });
    section.querySelectorAll('[data-collection-select]').forEach((select) => {
      on(select, 'change', () => location.assign(select.value));
    });
    const defaultSort = section.querySelector('[data-default-sort]');
    if (defaultSort) {
      const url = new URL(location.href);
      if (!url.searchParams.has('sort_by')) {
        url.searchParams.set('sort_by', defaultSort.dataset.defaultSort);
        location.replace(url.toString());
      }
    }

    const loadNextPage = async () => {
      if (!isActive() || !loadMoreButton?.isConnected || !loadMoreButton.dataset.nextUrl || loading) return false;
      loading = true;
      loadMoreButton.disabled = true;
      loadMoreButton.setAttribute('aria-disabled', 'true');
      productGrid.setAttribute('aria-busy', 'true');
      observer?.unobserve(loadMoreButton);
      try {
        const response = await fetch(loadMoreButton.dataset.nextUrl, { headers: { Accept: 'text/html' }, signal });
        if (!response.ok) throw new Error('Unable to load products');
        const html = await response.text();
        if (!isActive()) return false;
        const page = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = page.querySelector('[data-product-grid]');
        if (!nextGrid) throw new Error('Product grid missing');
        productGrid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
        const nextButton = page.querySelector('[data-load-more]');
        loadMoreButton.dataset.nextUrl = nextButton?.dataset.nextUrl || '';
        if (loadMoreButton.tagName === 'A' && loadMoreButton.dataset.nextUrl) loadMoreButton.href = loadMoreButton.dataset.nextUrl;
        productGrid.dataset.loadedPages = String(Number(productGrid.dataset.loadedPages) + 1);
        loadMoreButton.dataset.loadedPages = productGrid.dataset.loadedPages;
        const count = productGrid.querySelectorAll('.product-card').length;
        const total = Number(loadMoreButton.dataset.total || count);
        loadMoreButton.textContent = loadMoreButton.dataset.label + ' · ' + count + ' / ' + total;
        if (!loadMoreButton.dataset.nextUrl || count >= total) loadMoreButton.remove();
        return true;
      } catch {
        automaticPaused = true;
        if (isActive()) loadMoreButton.textContent = loadMoreButton.dataset.error || 'Unable to load products. Try again.';
        return false;
      } finally {
        loading = false;
        productGrid.removeAttribute('aria-busy');
        if (isActive() && loadMoreButton?.isConnected) {
          loadMoreButton.disabled = false;
          loadMoreButton.removeAttribute('aria-disabled');
          observeMore();
        }
      }
    };
    on(loadMoreButton, 'click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      automaticPaused = false;
      void loadNextPage();
    });
    if (loadMoreButton?.hasAttribute('data-auto-load') && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (restoringCollection || automaticPaused || document.hidden) return;
        if (entries.some(entry => entry.isIntersecting)) void loadNextPage();
      }, { rootMargin: '0px 0px 200px 0px' });
      observeMore();
    }
    if (loadMoreButton?.hasAttribute('data-auto-load')) {
      window.addEventListener('scroll', observeMore, { passive: true, signal });
      window.addEventListener('resize', observeMore, { passive: true, signal });
      on(document, 'visibilitychange', observeMore);
      on(window.visualViewport, 'resize', observeMore);
      observeMore();
    }
    on(productGrid, 'click', (event) => {
      if (!event.target.closest('[data-product-link]')) return;
      try {
        sessionStorage.setItem('humble-return', JSON.stringify({
          url: location.pathname + location.search,
          y: scrollY,
          pages: Number(productGrid.dataset.loadedPages),
        }));
      } catch {}
    });
    collectionSections.set(productGrid, {
      loadNextPage,
      observeMore,
      isActive,
      dispose: () => {
        controller.abort();
        observer?.disconnect();
        cancelAnimationFrame(observeFrame);
        if (loadMoreButton?.isConnected) {
          loadMoreButton.disabled = false;
          loadMoreButton.removeAttribute('aria-disabled');
        }
      },
    });
  }
  async function initializeCollectionSections(root = document) {
    collectionSections.forEach((collection, grid) => {
      if (!grid.isConnected) {
        collection.dispose();
        collectionSections.delete(grid);
      }
    });
    await Promise.all([...root.querySelectorAll('[data-product-grid]')].map(async (grid) => {
      if (!collectionPreparation.has(grid)) collectionPreparation.set(grid, prepareCollectionGrid(grid));
      if (await collectionPreparation.get(grid)) initializeCollectionSection(grid);
    }));
  }
  const initialCollectionsReady = initializeCollectionSections();
  document.addEventListener('shopify:section:load', (event) => initializeCollectionSections(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    collectionSections.forEach((collection, grid) => {
      if (event.target.contains(grid)) {
        collection.dispose();
        collectionSections.delete(grid);
      }
    });
  });
  async function restoreCollectionPosition() {
    restoringCollection = true;
    await initialCollectionsReady;
    try {
      const state = JSON.parse(sessionStorage.getItem('humble-return') || 'null');
      if (state?.url !== location.pathname + location.search) return;
      const grid = document.querySelector('[data-product-grid]');
      const collection = collectionSections.get(grid);
      if (!collection?.isActive()) return;
      while (Number(grid.dataset.loadedPages) < Number(state.pages || 1)) {
        if (!await collection.loadNextPage()) break;
      }
      if (!collection.isActive()) return;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (collection.isActive()) scrollTo(0, state.y);
      }));
      sessionStorage.removeItem('humble-return');
    } catch {
      try { sessionStorage.removeItem('humble-return'); } catch {}
    } finally {
      restoringCollection = false;
      collectionSections.forEach(collection => collection.observeMore());
    }
  }
  void restoreCollectionPosition();
  addEventListener('pageshow', (event) => {
    if (event.persisted) void restoreCollectionPosition();
  });

  const productSections = new Map();
  function initializeProductSection(section) {
    const productForm = section.querySelector('[data-product-form]');
    if (!productForm || productSections.has(productForm)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const on = (target, type, handler) => target?.addEventListener(type, handler, { signal });
    let disposeLightbox = () => {};
    productSections.set(productForm, () => {
      controller.abort();
      disposeLightbox();
    });

    section.querySelectorAll('[data-gallery-more]').forEach((button) => {
      on(button, 'click', () => {
        const gallery = button.closest('.detail-gallery');
        gallery?.classList.add('is-expanded');
        button.remove();
      });
    });

    const lightbox = section.querySelector('[data-image-lightbox]');
    const allGalleryButtons = [...section.querySelectorAll('[data-gallery-index]')];
    let galleryButtons = [...allGalleryButtons];
    const mobileGallery = section.querySelector('.detail-gallery');
    const mobileViewport = matchMedia('(max-width: 900px)');
    let mobileIndex = 0;
    let swipeStart = null;
    let suppressGalleryClickUntil = 0;
    const showMobileImage = (index) => {
      if (!galleryButtons.length || !mobileGallery) return;
      mobileIndex = (index + galleryButtons.length) % galleryButtons.length;
      allGalleryButtons.forEach((button) => button.closest('figure').classList.toggle('is-mobile-current', button === galleryButtons[mobileIndex]));
      mobileGallery.classList.add('is-mobile-carousel');
      const status = mobileGallery.querySelector('[data-mobile-gallery-status]');
      if (status) status.textContent = `${mobileIndex + 1} / ${galleryButtons.length}`;
      mobileGallery.querySelectorAll('.mobile-gallery-arrow').forEach((arrow) => { arrow.hidden = galleryButtons.length < 2; });
      const image = galleryButtons[mobileIndex].querySelector('img');
      if (mobileViewport.matches && image) image.loading = 'eager';
    };
    on(section.querySelector('[data-mobile-gallery-previous]'), 'click', () => showMobileImage(mobileIndex - 1));
    on(section.querySelector('[data-mobile-gallery-next]'), 'click', () => showMobileImage(mobileIndex + 1));
    on(mobileGallery, 'pointerdown', (event) => {
      if (!mobileViewport.matches || !event.isPrimary || event.button !== 0 || !event.target.closest('.gallery-open')) return;
      swipeStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    });
    on(mobileGallery, 'pointerup', (event) => {
      if (!swipeStart || event.pointerId !== swipeStart.id) return;
      const dx = event.clientX - swipeStart.x;
      const dy = event.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      suppressGalleryClickUntil = Date.now() + 500;
      showMobileImage(mobileIndex + (dx < 0 ? 1 : -1));
    });
    on(mobileGallery, 'pointercancel', () => { swipeStart = null; });
    on(mobileGallery, 'dragstart', (event) => { if (mobileViewport.matches) event.preventDefault(); });
    on(mobileGallery, 'keydown', (event) => {
      if (!mobileViewport.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const imageHadFocus = document.activeElement?.matches('.gallery-open');
      showMobileImage(mobileIndex + (event.key === 'ArrowRight' ? 1 : -1));
      if (imageHadFocus) galleryButtons[mobileIndex].focus({ preventScroll: true });
    });
    const numberedGallery = section.querySelector('[data-numbered-pieces]');
    const updateNumberedGallery = (variant) => {
      if (!numberedGallery || !variant) return;
      const piece = variant.options?.[1]?.replace(/^Col#/, 'No. ');
      const size = variant.options?.[0];
      const pieceVariants = JSON.parse(productForm.querySelector('[data-variants-json]').textContent);
      productForm.querySelectorAll('[data-option-index="1"] [data-option-value]').forEach(button => {
        const matches = pieceVariants.filter(v => v.options[0] === size && v.options[1] === button.dataset.optionValue);
        button.hidden = matches.length === 0;
        button.disabled = matches.length === 0;
        button.classList.toggle('unavailable', !matches.some(v => v.available));
      });
      const gallery = section.querySelector('.detail-gallery');
      const lead = gallery.querySelector('.detail-lead');
      let back = null;
      for (const figure of gallery.querySelectorAll('figure[data-source-alt]')) {
        const alt = figure.dataset.sourceAlt;
        figure.classList.remove('is-piece-back');
        const match = alt.match(/Size (\d+) \/ (No\. \d+) — (front|back)/i);
        figure.hidden = Boolean(match && (match[1] !== size || match[2] !== piece || match[3].toLowerCase() === 'front'));
        if (match && match[1] === size && match[2] === piece && match[3].toLowerCase() === 'back') back = figure;
      }
      if (back) { back.classList.add('is-piece-back'); lead.after(back); }
      gallery.classList.add('is-expanded');
      gallery.querySelector('[data-gallery-more]')?.setAttribute('hidden', '');
      galleryButtons = [...gallery.querySelectorAll('[data-gallery-index]')].filter(button => !button.closest('figure').hidden);
      galleryButtons.forEach((button, index) => {
        button.dataset.galleryIndex = index;
        if (gallery.dataset.galleryLabel) button.setAttribute('aria-label', gallery.dataset.galleryLabel.replace('__INDEX__', String(index + 1)));
        const sourceAlt = button.closest('figure').dataset.sourceAlt;
        if (sourceAlt) button.dataset.galleryAlt = sourceAlt;
      });
    };
    if (numberedGallery) {
      const values = JSON.parse(productForm.querySelector('[data-variants-json]').textContent);
      updateNumberedGallery(values.find(v => String(v.id) === productForm.querySelector('[data-variant-select]').value));
    }
    showMobileImage(0);
    if (lightbox && galleryButtons.length) {
      const image = lightbox.querySelector('[data-lightbox-image]');
      const count = lightbox.querySelector('[data-lightbox-count]');
      const close = lightbox.querySelector('[data-lightbox-close-button]');
      let active = 0;
      let returnFocus = null;
      let previousOverflow = '';
      const neighborImages = new Map();
      const preloadNeighbors = () => {
        const sources = new Set([1, -1].map((offset) =>
          galleryButtons[(active + offset + galleryButtons.length) % galleryButtons.length].dataset.gallerySrc
        ));
        for (const [url] of neighborImages) if (!sources.has(url)) neighborImages.delete(url);
        for (const url of sources) {
          if (!url || url === image.src || neighborImages.has(url)) continue;
          const preload = new Image();
          preload.decoding = 'async';
          preload.fetchPriority = 'low';
          neighborImages.set(url, preload);
          preload.onerror = () => neighborImages.delete(url);
          preload.src = url;
          if (preload.decode) preload.decode().catch(() => {});
        }
      };
      const show = (index) => {
        active = (index + galleryButtons.length) % galleryButtons.length;
        const source = galleryButtons[active];
        image.src = source.dataset.gallerySrc;
        image.alt = source.dataset.galleryAlt || '';
        count.textContent = (active + 1) + ' / ' + galleryButtons.length;
        preloadNeighbors();
      };
      const open = (button) => {
        returnFocus = button;
        show(Number(button.dataset.galleryIndex || 0));
        if (lightbox.hidden) previousOverflow = document.body.style.overflow;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        close?.focus();
      };
      const closeLightbox = (restoreFocus = true) => {
        if (lightbox.hidden) return;
        lightbox.hidden = true;
        document.body.style.overflow = previousOverflow;
        if (restoreFocus && returnFocus?.isConnected) returnFocus.focus();
      };
      disposeLightbox = () => closeLightbox(false);
      allGalleryButtons.forEach((button) => on(button, 'click', () => { if (Date.now() >= suppressGalleryClickUntil) open(button); }));
      lightbox.querySelectorAll('[data-lightbox-close]').forEach((button) => on(button, 'click', closeLightbox));
      on(lightbox.querySelector('[data-lightbox-previous]'), 'click', () => show(active - 1));
      on(lightbox.querySelector('[data-lightbox-next]'), 'click', () => show(active + 1));
      on(document, 'keydown', (event) => {
        if (lightbox.hidden) return;
        if (event.key === 'Tab') {
          const controls = [...lightbox.querySelectorAll('button:not([disabled])')]
            .filter((control) => control.tabIndex >= 0 && control.getClientRects().length);
          if (controls.length) {
            event.preventDefault();
            const current = controls.indexOf(document.activeElement);
            const next = current < 0 ? (event.shiftKey ? controls.length - 1 : 0)
              : (current + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
            controls[next].focus();
          }
        }
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') show(active - 1);
        if (event.key === 'ArrowRight') show(active + 1);
      });
    }

    if (productForm) {
      const variants = JSON.parse(productForm.querySelector('[data-variants-json]')?.textContent || '[]');
      const selector = productForm.querySelector('[data-variant-select]');
      const price = section.querySelector('[data-product-price]');
      const button = productForm.querySelector('[type=submit]');
      const variantPrices = JSON.parse(productForm.querySelector('[data-variant-prices]')?.textContent || '{}');
      const formatMoney = (cents, variantId, key) => variantPrices[variantId]?.[key]
        || (Number(cents) / 100).toFixed(2) + ' ' + (productForm.dataset.currencyCode || 'USD');
      const imageWithWidth = (source, width) => {
        const normalized = source.startsWith('//') ? 'https:' + source : source;
        const url = new URL(normalized, location.href);
        url.searchParams.set('width', String(width));
        return url.toString();
      };
      on(selector, 'change', () => {
        const variant = variants.find((item) => String(item.id) === selector.value);
        if (!variant) return;
        const variantUrl = new URL(location.href);
        variantUrl.searchParams.set('variant', String(variant.id));
        history.replaceState(history.state, '', variantUrl);
        const copyLink = section.querySelector('[data-share-url]');
        if (copyLink) {
          const shareUrl = new URL(copyLink.dataset.shareUrl, location.origin);
          shareUrl.searchParams.set('variant', String(variant.id));
          copyLink.dataset.shareUrl = shareUrl.toString();
          const facebook = section.querySelector('[data-share-facebook]');
          if (facebook) {
            const url = new URL(facebook.href);
            url.searchParams.set('u', shareUrl.toString());
            facebook.href = url.toString();
          }
          const email = section.querySelector('[data-share-email]');
          if (email) {
            const url = new URL(email.href);
            url.searchParams.set('body', shareUrl.toString());
            email.href = url.toString();
          }
        }
        const isFinalSale = Number(variant.compare_at_price || 0) > Number(variant.price);
        section.querySelectorAll('[data-final-sale-notice]').forEach((notice) => { notice.hidden = !isFinalSale; });
        section.querySelectorAll('[data-final-sale-exclusive]').forEach((noticeSection) => { noticeSection.hidden = !isFinalSale; });
        if (price) {
          price.textContent = '';
          if (isFinalSale) {
            const compare = document.createElement('del');
            compare.className = 'compare-at-price';
            compare.textContent = formatMoney(variant.compare_at_price, variant.id, 'compare');
            price.append(compare);
          }
          price.append(document.createTextNode(formatMoney(variant.price, variant.id, 'price')));
          if (isFinalSale) {
            const finalSale = document.createElement('span');
            finalSale.className = 'detail-sale-status';
            finalSale.textContent = ' · ' + price.dataset.finalSaleLabel;
            price.append(finalSale);
          }
        }
        if (button) {
          button.disabled = !variant.available;
          const label = variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
          if (label) button.textContent = label;
        }
        updateNumberedGallery(variant);
        showMobileImage(0);
        const featuredImage = variant.featured_image;
        const featured = featuredImage?.src;
        if (featured) {
          const lead = section.querySelector('.detail-lead img');
          if (lead) {
            const widths = [360, 480, 640, 720, 750, 960, 1200, 1800];
            if (featuredImage.width && featuredImage.height) {
              lead.sizes = `(max-width: 900px) min(100vw, ${featuredImage.width / featuredImage.height * 65}svh), 50vw`;
            }
            lead.srcset = widths.map((width) => imageWithWidth(featured, width) + ' ' + width + 'w').join(', ');
            lead.src = imageWithWidth(featured, 1800);
            if (featuredImage.width) lead.width = featuredImage.width;
            if (featuredImage.height) lead.height = featuredImage.height;
          }
          const leadButton = section.querySelector('.detail-lead [data-gallery-index]');
          if (leadButton) {
            leadButton.dataset.gallerySrc = imageWithWidth(featured, 2400);
            leadButton.dataset.galleryAlt = featuredImage.alt || section.querySelector('h1')?.textContent || '';
          }
        }
      });
      productForm.querySelectorAll('[data-option-value]').forEach((optionButton) => {
        on(optionButton, 'click', () => {
          const group = optionButton.closest('[data-option-index]');
          const optionIndex = Number(group?.dataset.optionIndex);
          if (!group || Number.isNaN(optionIndex) || !selector) return;
          const selectedOptions = [...productForm.querySelectorAll('[data-option-index]')].map((optionGroup) => optionGroup.querySelector('[data-option-value][aria-pressed=true]')?.dataset.optionValue);
          selectedOptions[optionIndex] = optionButton.dataset.optionValue;
          const exact = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
          const fallback = variants.find((item) => item.available && item.options[optionIndex] === optionButton.dataset.optionValue);
          const variant = exact || fallback || variants.find((item) => item.options[optionIndex] === optionButton.dataset.optionValue);
          if (!variant) return;
          productForm.querySelectorAll('[data-option-index]').forEach((optionGroup) => {
            const index = Number(optionGroup.dataset.optionIndex);
            optionGroup.querySelectorAll('[data-option-value]').forEach((option) => option.setAttribute('aria-pressed', String(option.dataset.optionValue === variant.options[index])));
          });
          selector.value = String(variant.id);
          selector.dispatchEvent(new Event('change', { bubbles: true }));
          if (group.hasAttribute('data-preview-on-select') && matchMedia('(max-width: 900px)').matches) {
            requestAnimationFrame(() => {
              const lead = section.querySelector('.detail-lead');
              if (!lead || !lead.isConnected) return;
              const headerHeight = (document.querySelector('.site-header')?.getBoundingClientRect().height || 54) + (document.querySelector('.site-shipping-note')?.getBoundingClientRect().height || 0);
              window.scrollTo({
                top: Math.max(0, window.scrollY + lead.getBoundingClientRect().top - headerHeight - 12),
                behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
              });
            });
          }
        });
      });

    }
  }

  function initializeProductSections(root = document) {
    productSections.forEach((dispose, form) => {
      if (!form.isConnected) {
        dispose();
        productSections.delete(form);
      }
    });
    root.querySelectorAll('[data-product-form]').forEach((form) => {
      initializeProductSection(form.closest('.shopify-section') || form.parentElement);
    });
  }
  initializeProductSections();
  document.addEventListener('shopify:section:load', (event) => initializeProductSections(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    productSections.forEach((dispose, form) => {
      if (event.target.contains(form)) {
        dispose();
        productSections.delete(form);
      }
    });
  });
  const syncQuantityStepper = (stepper) => {
    const input = stepper?.querySelector('.quantity-stepper-input');
    if (!input) return;
    const value = input.valueAsNumber;
    const minimum = input.min === '' ? -Infinity : Number(input.min);
    const maximum = input.max === '' ? Infinity : Number(input.max);
    const increase = stepper.querySelector('[data-quantity-adjust="increase"]');
    const decrease = stepper.querySelector('[data-quantity-adjust="decrease"]');
    if (increase) increase.disabled = input.disabled || (Number.isFinite(value) && value >= maximum);
    if (decrease) decrease.disabled = input.disabled || (Number.isFinite(value) && value <= minimum);
  };

  const syncQuantitySteppers = (root = document) => {
    root.querySelectorAll('[data-quantity-stepper]').forEach(syncQuantityStepper);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-adjust]');
    if (!button) return;
    const stepper = button.closest('[data-quantity-stepper]');
    const input = stepper?.querySelector('.quantity-stepper-input');
    if (!input || input.disabled) return;
    if (!Number.isFinite(input.valueAsNumber)) input.value = input.min || '1';
    try {
      if (button.dataset.quantityAdjust === 'increase') input.stepUp();
      else input.stepDown();
    } catch {
      return;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    syncQuantityStepper(stepper);
  });

  document.addEventListener('input', (event) => {
    const stepper = event.target.closest?.('[data-quantity-stepper]');
    if (stepper) syncQuantityStepper(stepper);
  });

  syncQuantitySteppers();
  document.addEventListener('shopify:section:load', (event) => syncQuantitySteppers(event.target));

})();


// Automatically commit cart quantities; prices and notices are rendered by Shopify.
(() => {
  let timer;
  let busy = false;
  const inputSelector = '[data-auto-cart] [name="updates[]"]';
  const showStatus = (page, message, error = false) => {
    const status = page.querySelector('[data-cart-update-status]');
    if (!status) return;
    status.hidden = false;
    status.textContent = message;
    status.toggleAttribute('data-error', error);
  };
  const commitQuantity = async (input) => {
    clearTimeout(timer);
    if (busy || !input.isConnected || !input.checkValidity() || input.value === '') return;
    if (input.value === input.defaultValue) return;
    const page = input.closest('[data-auto-cart]');
    const form = input.form;
    const quantity = input.valueAsNumber;
    if (!Number.isInteger(quantity)) return;
    busy = true;
    page.setAttribute('aria-busy', 'true');
    const active = document.activeElement;
    const focusKey = active?.closest('.cart-item')?.querySelector('[data-cart-key]')?.dataset.cartKey;
    const focusAction = active?.dataset.quantityAdjust;
    const focusInput = active?.matches('[name="updates[]"]');
    const controls = [...form.querySelectorAll('[name="updates[]"], [data-quantity-adjust], button[type="submit"]')];
    const wasDisabled = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    showStatus(page, page.dataset.updating);
    try {
      const response = await fetch(page.dataset.changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: input.dataset.cartKey, quantity, sections: [page.dataset.sectionId], sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || page.dataset.updateError);
      const html = cart.sections?.[page.dataset.sectionId];
      if (!html) throw new Error(page.dataset.updateError);
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-auto-cart]');
      if (!next) throw new Error(page.dataset.updateError);
      if (!next.querySelector('.cart-form')) {
        page.replaceChildren(...next.childNodes);
      } else {
        // Keep note/coupon fields and their listeners intact, including unsaved text.
        for (const selector of ['.cart-title', '.cart-items', '.cart-summary > div:first-of-type', '[data-cart-notices]', '[data-cart-discounts]']) {
          const oldPart = page.querySelector(selector);
          const newPart = next.querySelector(selector);
          if (oldPart && newPart) oldPart.replaceWith(newPart);
        }
        const checkout = form.querySelector('[name="checkout"]');
        const nextCheckout = next.querySelector('[name="checkout"]');
        if (checkout && nextCheckout) {
          wasDisabled[controls.indexOf(checkout)] = nextCheckout.disabled;
          if (nextCheckout.hasAttribute('aria-describedby')) checkout.setAttribute('aria-describedby', nextCheckout.getAttribute('aria-describedby'));
          else checkout.removeAttribute('aria-describedby');
        }
      }
      document.querySelectorAll('.bag-count').forEach(badge => {
        badge.textContent = String(cart.item_count);
        badge.hidden = cart.item_count === 0;
      });
      showStatus(page, page.dataset.updated);
    } catch (error) {
      // Restore the last confirmed quantities and retain the native update fallback.
      form.querySelectorAll('[name="updates[]"]').forEach(field => { field.value = field.defaultValue; });
      showStatus(page, error.message || page.dataset.updateError, true);
    } finally {
      controls.forEach((control, index) => { if (control.isConnected) control.disabled = wasDisabled[index]; });
      page.querySelectorAll('[data-quantity-stepper]').forEach(stepper => {
        const field = stepper.querySelector('[name="updates[]"]');
        if (!field) return;
        stepper.querySelector('[data-quantity-adjust="decrease"]').disabled = field.valueAsNumber <= Number(field.min || 0);
        stepper.querySelector('[data-quantity-adjust="increase"]').disabled = field.max !== '' && field.valueAsNumber >= Number(field.max);
      });
      page.removeAttribute('aria-busy');
      busy = false;
      // Restore keyboard focus only if the customer has not moved elsewhere.
      if ((focusInput || focusAction) && (document.activeElement === active || document.activeElement === document.body)) {
        const restored = [...page.querySelectorAll('[data-cart-key]')].find(field => field.dataset.cartKey === focusKey);
        const target = focusAction ? restored?.closest('[data-quantity-stepper]')?.querySelector('[data-quantity-adjust="' + focusAction + '"]') : restored;
        (target && !target.disabled ? target : restored)?.focus({ preventScroll: true });
      }
    }
  };
  document.addEventListener('input', event => {
    if (!event.target.matches(inputSelector) || busy) return;
    clearTimeout(timer);
    timer = setTimeout(() => { void commitQuantity(event.target); }, 450);
  });
  document.addEventListener('change', event => {
    if (event.target.matches(inputSelector)) void commitQuantity(event.target);
  });
  // Do not allow a native checkout/update submission to race an in-flight change.
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-auto-cart] .cart-form')) return;
    clearTimeout(timer);
    if (busy) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
})();


